module.exports = __webpack_public_path__ + "static/media/IG_logo.746fa227.svg";